import moment from 'moment'
import { get } from 'lodash'
import scheduleStatus from '@/helpers/scheduleStatus'

const prepareShow = schedule => {
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = moment(schedule.date).format('DD/MM/YYYY')
  schedule.speciality = get(schedule, 'speciality.name', 'Não informada')
  schedule.professional = get(schedule, 'agenda.professional.name')
  schedule.status = scheduleStatus(schedule.status)
  return schedule
}

export default function () {
  this.$resource.get(this.schedule.id + '/patient/history')
    .then(({data}) => {
      this.schedules = data.map(prepareShow)
    })
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/consultations-made/resources/mounted.js